import { useContext } from 'react';

import Untabbable from './Untabbable';

export default function useTabIndex(value) {
  const inert = useContext(Untabbable.Context);
  return inert ? -1 : value;
}
